import {Card} from "./card/card";

export class NewsCard extends Card{
  constructor(title:string,summary:string,unid:string,urlId:string,showDate:number){
    super(title,summary,unid,urlId,showDate);
  }
}
